import React from 'react';
import PropTypes from 'prop-types';
import { StyledListSubheader } from './styled';

const ListSubheader = ({ children, customStyle }) => {
    return (
        <StyledListSubheader
            customStyle={customStyle}
        >
            {children}
        </StyledListSubheader>
    );
};

ListSubheader.propTypes = {
    children: PropTypes.node,
    customStyle: PropTypes.array
};

ListSubheader.defaultProps = {
};

export default React.memo(ListSubheader);
